// const DEMOCRAT = [
//   '#08589e',
//   '#2b8cbe',
//   '#4eb3d3',
//   '#7bccc4',
//   '#a8ddb5',
//   '#ccebc5',
//   '#f0f9e8',
// ];
//
// const REPUBLICAN = [
//   '#990000',
//   '#d7301f',
//   '#ef6548',
//   '#fc8d59',
//   '#fdbb84',
//   '#fdd49e',
//   '#fef0d9',
// ];

const DEMOCRAT = [
  '#3486ff',
  '#619f1b',
  '#79c9ab',
  '#0d5979',
  '#69d6fd',
  '#bcdce8',
];

const REPUBLICAN = [
  '#f24b4b',
  '#a40554',
  '#c075e3',
  '#6b22bd',
  '#ff8f05',
  '#ffabab',
];

const NEUTRAL = '#d1d1d1';
const TIE = '#999999';

export { DEMOCRAT, NEUTRAL, REPUBLICAN, TIE };



// WEBPACK FOOTER //
// ./utils/primary-colors.js